import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 803E5E8E-04C6-41E1-9EE0-B8C3C723D507
 * name keyboard-space
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/keyboard-space.svg
 * tags
 */
export const KeyboardSpaceIcon = createSvgIcon(<><path d="M3 15H5V19H19V15H21V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V15Z" /></>, 'KeyboardSpaceIcon');
export default KeyboardSpaceIcon